export default {
    apiPostRequirement(data, urldata = {}) {
        return this.request(this.api().postRequirement, data)
            .urltransform({
                ...urldata,
                ...mixins.params(),
                ...(app.props.store?.lastcreditcreated||{})
            })
            .exec().log().get();
    },
    apiGetRequirement(data, urldata = {}) {
        return this.request(this.api().getRequirement, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiPutRequirement(data, urldata = {}) {
        return this.request(this.api().putRequirement, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    }
}